// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dITGx0dc>*+*{margin-top:max(1rem,min(2.92vw,3.5rem))}.QA4dQ-D\\+{font-size:max(1.75rem,min(3.33vw,4rem));font-weight:400;line-height:1;text-transform:uppercase;text-wrap:balance}.QA4dQ-D\\+ span{color:#bf2333}@media(max-width:667.98px){.QA4dQ-D\\+ br{display:none}}.UWwWELXF{color:#434343;font-size:max(1rem,min(1.04vw,1.25rem));font-weight:500;line-height:1.4;max-width:70ch}.q8AY7Dnf{align-items:center;background-color:#f5f6ff;border-radius:max(1.25rem,min(2.08vw,2.5rem));display:flex;justify-content:space-between;padding:max(1rem,min(2.08vw,2.5rem))}.q8AY7Dnf>*+*{margin-left:max(2rem,min(2.08vw,2.5rem))}@media(max-width:1023.98px){.q8AY7Dnf{display:block}.q8AY7Dnf>*+*{margin-left:0;margin-top:max(2rem,min(2.08vw,2.5rem))}.q8AY7Dnf .\\+owOtoj0{width:100%}}@media(max-width:667.98px){.q8AY7Dnf{margin-left:calc(var(--p-x)*-1);margin-right:calc(var(--p-x)*-1)}}.ley\\+O-D6{flex-basis:28.13rem}.ley\\+O-D6>*+*{margin-top:1.25rem}.SN-fxAwL{font-size:1.25rem;font-weight:400;line-height:1;text-transform:uppercase;text-wrap:balance}.ms8\\+jvCx{font-size:.88rem;line-height:1.4}.\\+owOtoj0{border-radius:1.25rem;height:auto;-o-object-fit:cover;object-fit:cover;width:max(31.25rem,min(32.55vw,39.06rem))}@media(max-width:667.98px){.\\+owOtoj0{height:13.75rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "dITGx0dc",
	"title": "QA4dQ-D+",
	"text": "UWwWELXF",
	"card": "q8AY7Dnf",
	"cardImg": "+owOtoj0",
	"cardTextWrapper": "ley+O-D6",
	"cardTitle": "SN-fxAwL",
	"cardText": "ms8+jvCx"
};
module.exports = ___CSS_LOADER_EXPORT___;
